const map = {
	"./altium_designer.png": 3528,
	"./autodesk_eagle.png": 3665,
	"./autodesk_fusion_360.png": 3641,
	"./diptrace.png": 8284,
	"./fritzing.png": 3907,
	"./gdpr_compliant.png": 9387,
	"./horizon_eda.png": 1712,
	"./hosted_in_germany.png": 4283,
	"./kicad.png": 9724,
	"./librepcb.png": 4171,
	"./made_in_europe.png": 8270,
	"./pulsonix.png": 7836,
	"./sprint_layout.png": 7073,
	"./target.png": 3593,
	"./zuken.png": 3455
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2096;